import { render, staticRenderFns } from "./ClientFilter.vue?vue&type=template&id=3877e180&"
import script from "./ClientFilter.vue?vue&type=script&lang=ts&"
export * from "./ClientFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports